// src/store/actions/categoryActions.js
import { CATEGORY_ACTIONS } from './actionTypes';
import categoryService from '../../services/categoryService';

// Fetch categories
export const fetchCategories = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.FETCH_CATEGORIES_REQUEST });

    const response = await categoryService.getCategories(params);
    
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORIES_FAILURE,
      payload: error.message || 'Failed to fetch categories',
    });
  }
};

// Fetch single category
export const fetchCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.FETCH_CATEGORY_REQUEST });

    const response = await categoryService.getCategoryById(id);
    
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_FAILURE,
      payload: error.message || 'Failed to fetch category',
    });
    throw error;
  }
};

// Create category
export const createCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.CREATE_CATEGORY_REQUEST });

    const response = await categoryService.createCategory(categoryData);
    
    dispatch({
      type: CATEGORY_ACTIONS.CREATE_CATEGORY_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.CREATE_CATEGORY_FAILURE,
      payload: error.message || 'Failed to create category',
    });
    throw error;
  }
};

// Update category
export const updateCategory = (id, categoryData) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.UPDATE_CATEGORY_REQUEST });

    const response = await categoryService.updateCategory(id, categoryData);
    
    dispatch({
      type: CATEGORY_ACTIONS.UPDATE_CATEGORY_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.UPDATE_CATEGORY_FAILURE,
      payload: error.message || 'Failed to update category',
    });
    throw error;
  }
};

// Delete category
export const deleteCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.DELETE_CATEGORY_REQUEST });

    const response = await categoryService.deleteCategory(id);
    
    dispatch({
      type: CATEGORY_ACTIONS.DELETE_CATEGORY_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.DELETE_CATEGORY_FAILURE,
      payload: error.message || 'Failed to delete category',
    });
    throw error;
  }
};

// Get category tree
export const fetchCategoryTree = (type) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_REQUEST });

    const response = await categoryService.getCategoryTree(type);
    
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_FAILURE,
      payload: error.message || 'Failed to fetch category tree',
    });
  }
};

// Get category stats
export const fetchCategoryStats = (id) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_REQUEST });

    const response = await categoryService.getCategoryStats(id);
    
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_FAILURE,
      payload: error.message || 'Failed to fetch category stats',
    });
  }
};

// Bulk delete categories
export const bulkDeleteCategories = (ids) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_REQUEST });

    const response = await categoryService.bulkDeleteCategories(ids);
    
    dispatch({
      type: CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_FAILURE,
      payload: error.message || 'Failed to bulk delete categories',
    });
    throw error;
  }
};

// Upload category image
export const uploadCategoryImage = (id, file) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_REQUEST });

    const response = await categoryService.uploadCategoryImage(id, file);
    
    dispatch({
      type: CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_FAILURE,
      payload: error.message || 'Failed to upload category image',
    });
    throw error;
  }
};

// Reorder categories
export const reorderCategories = (orderedIds) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_ACTIONS.REORDER_CATEGORIES_REQUEST });

    const response = await categoryService.reorderCategories(orderedIds);
    
    dispatch({
      type: CATEGORY_ACTIONS.REORDER_CATEGORIES_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CATEGORY_ACTIONS.REORDER_CATEGORIES_FAILURE,
      payload: error.message || 'Failed to reorder categories',
    });
    throw error;
  }
};

// Set category filters
export const setCategoryFilters = (filters) => ({
  type: CATEGORY_ACTIONS.SET_CATEGORY_FILTERS,
  payload: filters,
});

// Clear error
export const clearCategoryError = () => ({
  type: CATEGORY_ACTIONS.CLEAR_CATEGORY_ERROR,
});

// Clear success
export const clearCategorySuccess = () => ({
  type: CATEGORY_ACTIONS.CLEAR_CATEGORY_SUCCESS,
});

// Clear selected category
export const clearSelectedCategory = () => ({
  type: CATEGORY_ACTIONS.CLEAR_SELECTED_CATEGORY,
});